(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-home"] && !Shopify.designMode) return;
  try {
    
function initSolarHome(root){
  if(root.dataset.initialized)return;
  const configEl=root.querySelector('[data-solar-config]');
  if(!configEl)return;
  root.dataset.initialized='true';
  const config=JSON.parse(configEl.textContent);
  const input=root.querySelector('input[name="address"]');
  const summary=root.querySelector('[data-address-summary]');
  const preview=root.querySelector('[data-address-preview]');
  const status=root.querySelector('[data-address-status]');
  const button=root.querySelector('[data-address-submit]');
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:config.currency});
  function selection(){const raw=input.value.toUpperCase().replace(/\s/g,'');if(!/^[0-9A-D]{1,12}$/.test(raw))return null;const counts=new Map();for(const ch of raw)counts.set(ch,(counts.get(ch)||0)+1);const items=[];let total=0;for(const [ch,quantity] of counts){const variant=config.variants.find(v=>v.title===ch);if(!variant||!variant.available)return null;items.push({id:variant.id,quantity});total+=variant.price*quantity;}return {raw,items,total};}
  const glyphs=new Map([...root.querySelectorAll('.sc-character[data-character]')].map(glyph=>[glyph.dataset.character,glyph]));
  function drawPreview(value){preview.replaceChildren();for(const character of value){const glyph=glyphs.get(character);preview.append(glyph?glyph.cloneNode(true):document.createTextNode(character));}}
  drawPreview('208');
  input.addEventListener('input',()=>{const result=selection();drawPreview(input.value.toUpperCase().replace(/\s/g,'')||'—');summary.textContent=result?result.raw.length+' '+config.countLabel+' · '+formatter.format(result.total/100):config.invalid;status.textContent='';});
  root.querySelector('[data-address-form]').addEventListener('submit',async(event)=>{event.preventDefault();const result=selection();if(!result){status.textContent=config.unavailable;return;}button.disabled=true;input.disabled=true;button.textContent=config.adding;try{const response=await fetch(config.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:result.items})});if(!response.ok){let detail;try{detail=await response.json();}catch{}throw new Error(detail?.description||config.error);}window.location.assign(config.cartUrl);}catch(error){status.textContent=error.message||config.error;button.disabled=false;input.disabled=false;button.textContent=config.add;}});
}
document.querySelectorAll('[data-solar-home]').forEach(initSolarHome);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-solar-home]').forEach(initSolarHome));

  } catch(e) { console.error(e); }
})();
})();
